module.exports = "<menu-toolbar></menu-toolbar>\n<ui-view id=\"app-page\" class=\"layout-column flex\" style=\"margin-top: 48px;\"></ui-view>\n<div id=\"notify-container\">\n\t<div notify></div>\n</div>\n<div login-modal></div>\n\n";


//////////////////
// WEBPACK FOOTER
// ./scripts/core/main/views/main.html
// module id = 449
// module chunks = 0